import { ApiClientError, requestJson } from "@fluentry/shared-workbench/http";
import { clientEnv } from "./client-env";

const runtimeOrigin = typeof window !== "undefined" ? window.location.origin : "";

function isLocalHostname(hostname: string): boolean {
  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === "lvh.me" ||
    hostname.endsWith(".localhost") ||
    hostname.endsWith(".local") ||
    hostname.endsWith(".lvh.me")
  );
}

function normalizeOrigin(origin: string): string {
  return origin.replace(/\/+$/, "");
}

export function resolveAdminApiBaseUrl(
  nextRuntimeOrigin = typeof window !== "undefined" ? window.location.origin : "",
): string {
  if (nextRuntimeOrigin.startsWith("http://") || nextRuntimeOrigin.startsWith("https://")) {
    const hostname = new URL(nextRuntimeOrigin).hostname;
    if (!isLocalHostname(hostname)) {
      // Deployed admin web traffic should stay on same-origin /api so the edge worker can bridge privately to api-core.
      return normalizeOrigin(nextRuntimeOrigin);
    }
  }

  return (
    clientEnv.VITE_API_BASE_URL || (clientEnv.DEV ? "http://localhost:8787" : nextRuntimeOrigin)
  );
}

export function resolveAdminAuthAppOrigin(
  nextRuntimeOrigin = typeof window !== "undefined" ? window.location.origin : "",
): string {
  return (
    clientEnv.VITE_AUTH_APP_ORIGIN || (clientEnv.DEV ? "http://localhost:3001" : nextRuntimeOrigin)
  );
}

export const API_BASE_URL = resolveAdminApiBaseUrl(runtimeOrigin);
export const AUTH_APP_ORIGIN = resolveAdminAuthAppOrigin(runtimeOrigin);

export async function apiRequest<T>(
  path: string,
  init?: RequestInit & { bodyJson?: Record<string, unknown> },
): Promise<T> {
  // Keep admin API fetches on the shared request layer so envelope parsing and failures match the rest of the monorepo.
  return requestJson<T>(path, {
    apiBaseUrl: API_BASE_URL,
    ...init,
  });
}

export { ApiClientError };
